import { CitationDisplay } from "../enums/citation-display.enum";

export const CITATION_DISPLAY_LABELS: Record<CitationDisplay, string> = {
    [CitationDisplay.hidden]: "Hidden",
    [CitationDisplay.fileOnly]: "Name only",
    [CitationDisplay.pagesInfo]: "Pages (info)",
    [CitationDisplay.pagesLinked]: "Pages (linked)"
};

export const CITATION_DISPLAY_DESCRIPTIONS: Record<CitationDisplay, string> = {
    [CitationDisplay.hidden]: "Not shown in answers",
    [CitationDisplay.fileOnly]: "File name, no pages",
    [CitationDisplay.pagesInfo]: "Page numbers, not clickable",
    [CitationDisplay.pagesLinked]: "Page numbers open the file"
};

/**
 * Web site sources cite sections, not pages (web scraper design §9.4): the
 * enum values are unchanged, only the wording differs. A mixed Assistant keeps
 * each provider's own wording.
 */
export const WEB_CITATION_DISPLAY_LABELS: Record<CitationDisplay, string> = {
    [CitationDisplay.hidden]: "Hidden",
    [CitationDisplay.fileOnly]: "Name only",
    [CitationDisplay.pagesInfo]: "Sections (info)",
    [CitationDisplay.pagesLinked]: "Sections (linked)"
};

export const WEB_CITATION_DISPLAY_DESCRIPTIONS: Record<CitationDisplay, string> = {
    [CitationDisplay.hidden]: "Not shown in answers",
    [CitationDisplay.fileOnly]: "Page name, no sections",
    [CitationDisplay.pagesInfo]: "Section headings, not clickable",
    [CitationDisplay.pagesLinked]: "Section headings open the live page"
};

export const citationDisplayLabels = (webSite: boolean): Record<CitationDisplay, string> =>
    webSite ? WEB_CITATION_DISPLAY_LABELS : CITATION_DISPLAY_LABELS;

export const citationDisplayDescriptions = (webSite: boolean): Record<CitationDisplay, string> =>
    webSite ? WEB_CITATION_DISPLAY_DESCRIPTIONS : CITATION_DISPLAY_DESCRIPTIONS;

export const CITATION_DISPLAY_ORDER: CitationDisplay[] = [
    CitationDisplay.hidden,
    CitationDisplay.fileOnly,
    CitationDisplay.pagesInfo,
    CitationDisplay.pagesLinked
];
